import { logger } from '../lib/utils';
import { useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Singleton to store the fingerprint promise
let fingerprintPromise = null;

export function useFingerprint() {
  const [visitorId, setVisitorId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getFingerprint = async () => {
      try {
        // Use singleton pattern to avoid multiple initializations
        if (!fingerprintPromise) {
          fingerprintPromise = FingerprintJS.load().then(fp => fp.get());
        }
        
        const result = await fingerprintPromise;
        setVisitorId(result.visitorId);
      } catch (error) {
        logger.error('Failed to get fingerprint:', error);
        // Fallback to a random ID stored in localStorage
        let fallbackId = localStorage.getItem('jigsaw_fallback_device_id');
        if (!fallbackId) {
          fallbackId = 'fallback_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
          localStorage.setItem('jigsaw_fallback_device_id', fallbackId);
        }
        setVisitorId(fallbackId);
      } finally {
        setIsLoading(false);
      }
    };

    getFingerprint();
  }, []);

  return { visitorId, isLoading };
}
